/**
 * Shared parsing for dosage/package peptide variant names (e.g. "10mg - 2 Pack").
 * Used by PDP client selector and server-side price resolution.
 */

export function normalizePackageName(value: string): string {
	return value.trim().toLowerCase().replace(/\s+/g, " ");
}

export function parsePackageCount(packageName: string): number {
	const match = packageName.match(
		/(\d+)\s*(?:Pack(?:ung)?|Vials?|Stück|Fläschchen|Pieces?|Unidad(?:es)?|Pi[eè]ces?|Flacons?|Pezz[oi]|Fial[ae]|Stuks?|Flesjes?|Unidades?|Frascos?|Sztuk[ai]?|Szt\.?)/i,
	);
	return match ? parseInt(match[1]!, 10) : 1;
}

export function parseVariantName(name: string): { dosage: string; packageName: string } | null {
	const parts = name.split(" - ");
	if (parts.length < 2) return null;

	const left = parts[0]!.trim();
	const right = parts.slice(1).join(" - ").trim();

	const dosageMatch = left.match(/(\d+(?:[.,]\d+)?\s*(?:mg|ml)(?:\s*\/\s*\d+(?:[.,]\d+)?\s*(?:mg|ml))*)/i);
	const dosage = dosageMatch ? dosageMatch[1]!.replace(/\s+/g, " ").trim() : null;

	return {
		dosage: dosage ?? left,
		packageName: right,
	};
}
